<template>
  <div class="notice-container">
    <CardBox title="通知公告" subtitle="Real-time notices">
      <div class="notice-content-wrapper">
        <div class="notice-notice" v-if="noticeContent">
          <vue-seamless-scroll
            :data="[noticeContent]"
            :class-option="{
              limitMoveNum: 1,
              step: 0.4,
              hoverStop: true
            }"
            style="height: 100%"
          >
            <div class="notice-scroll-body">
              <div class="notice-title">
                {{ noticeTitle }}
              </div>
              <div class="notice-text" v-html="noticeContent"></div>
            </div>
          </vue-seamless-scroll>
        </div>
        <div class="notice-empty" v-else>暂无公告</div>
      </div>
    </CardBox>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { getTabberData } from '@utils'
import CardBox from './cardBox.vue'
import vueSeamlessScroll from 'vue-seamless-scroll/src'

export default {
  name: 'NoticeComponent',
  components: { CardBox, vueSeamlessScroll },
  setup() {
    const store = useStore()
    const { dispatch } = store
    const noticeTitle = ref('')
    const noticeContent = ref('')

    // 获取最新一条公告
    const fetchNotice = async () => {
      try {
        const { data } = await getTabberData(dispatch, 'fetchNewCompanyNoticeRecord')
        const { title, content = '' } = data || {}
        noticeTitle.value = title || ''
        let rawContent = content || ''
        if (rawContent) {
          rawContent = rawContent.replaceAll(' ', '&nbsp;')
        }
        noticeContent.value = rawContent
      } catch (e) {
        console.error('获取通知公告失败:', e)
      }
    }

    // 供父组件调用的定时刷新方法
    const refreshData = () => {
      fetchNotice()
    }

    onMounted(() => {
      fetchNotice()
    })

    return {
      noticeTitle,
      noticeContent,
      refreshData
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-container {
  width: 100%;
  height: 245px;
  margin-bottom: 20px;
}

.notice-content-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.notice-notice {
  height: 100%;
  overflow: hidden;
  word-break: break-all;
}

.notice-scroll-body {
  min-height: 160px;
  padding: 0 4px;
}

.notice-title {
  text-align: center;
  margin: 16px 0;
  font-size: 16px;
  color: #ffffff;
  font-family: 'SourceHanSansCN-Medium', sans-serif;
  font-weight: 500;
  letter-spacing: 1px;
}

.notice-text {
  color: #d5eaff;
  font-size: 14px;
  line-height: 1.8;
  text-align: justify;
}

.notice-empty {
  text-align: center;
  color: rgba(213, 234, 255, 0.4);
  line-height: 180px;
  font-size: 14px;
}
</style>
